export default __webpack_public_path__ + "static/media/icon-menu-calendar-active.bd1dc640.svg";